import React from 'react';

import BottomSheet from 'components/DesignSystem/BottomSheet';
import { ModelPerformanceLegendItem } from 'types/Meteorology/Fields/ModelPerformance/mapData';

import './index.scss';

function legendRowText(item: ModelPerformanceLegendItem): string {
  const isCategorical = item.max === null && item.min === 0;
  if (isCategorical) return item.label;
  const rangeText = item.max === null ? `${item.min}+` : `${item.min}–${item.max}`;
  return item.label ? `${rangeText} - ${item.label}` : rangeText;
}

export interface LegendSheetProps {
  open: boolean;
  dismiss: () => void;
  legend: ModelPerformanceLegendItem[];
  variable: string;
  unit: string;
}

export default function LegendSheet({
  open, dismiss, legend, variable, unit,
}: LegendSheetProps) {
  const title = variable ? `${variable}${unit ? ` (${unit})` : ''}` : 'Legenda';

  return (
    <BottomSheet open={open} dismiss={dismiss} title={title} className="mp-mobile-legend-sheet">
      <div className="mp-mobile-legend-sheet-body">
        {legend.length === 0 && (
          <p className="mp-mobile-legend-sheet-empty">Nenhuma legenda disponível.</p>
        )}
        {legend.map((item) => (
          <div key={`${item.color}-${item.label}-${item.min}`} className="mp-mobile-legend-sheet-row">
            <span className="mp-mobile-legend-sheet-swatch" style={{ backgroundColor: item.color }} />
            <span className="mp-mobile-legend-sheet-label">{legendRowText(item)}</span>
          </div>
        ))}
      </div>
    </BottomSheet>
  );
}
